import React from 'react';
import ReactDOM from "react-dom";

export class MobileNav extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            language: localStorage.getItem('language'),
            menuLinks: []
        }

        this.closeNav = this.closeNav.bind(this)
        this.toggleNav = this.toggleNav.bind(this)
    }

    closeNav() {
        this.setState({isOpen: false})
        const body = document.querySelector("body")
        body.classList.remove("menu-open")
    }

    toggleNav(e) {
        e.preventDefault()
        const body = document.querySelector("body")
        if (!this.state.isOpen) {
            body.classList.add("menu-open")
        } else {
            body.classList.remove("menu-open")
        }

        this.setState({isOpen: !this.state.isOpen})
    }

    componentDidMount() {
        let el = document.getElementById('mobile-nav')
        let data = el.getAttribute('data-items')
        let items = JSON.parse(data)
        this.setState({menuLinks: items})
    }

    render() {
        let icon = this.state.isOpen ? '/images/icons/hamburger-open.svg' : '/images/icons/hamburger-close.svg'

        return <nav className="lg:hidden grid items-center mr-1">
            <button className={"hamburger lg:hidden" + (this.state.isOpen ? ' active' : '')}
                    onClick={this.toggleNav}>
                <img src={icon} className="w-[36px] h-[36px]" alt="hamburger"/>
            </button>
            <div
                className={"fixed left-0 right-0 w-full h-full z-20 sm:top-[72px] top-[62px] bg-[#F6F9F9] p-8" + (!this.state.isOpen ? ' hidden' : '')}>
                <a href="tel:+3726104238" className="sm:hidden block absolute right-4 top-0 text-sm">+372 610 4238</a>
                <ul className="text-center font-semibold text-xl text-dark-main space-y-4 mt-14">
                    { this.state.menuLinks && this.state.menuLinks.map((item, index) => {
                       return <li key={index}><a href={item.url} className={"!text-black"}>{item.name}</a></li>
                    })}
                </ul>
                <div className="flex justify-center mt-14 gap-6">
                    <a href="?lang=ru" className={"!text-black " + (this.state.language === 'ru' ? 'font-medium' : '')}>RU</a>
                    <a href="?lang=et" className={"!text-black " + (this.state.language === 'et' ? 'font-medium' : '')}>ET</a>
                </div>
            </div>
        </nav>;
    }
}

if (document.getElementById('mobile-nav')) {
    ReactDOM.render(
        <MobileNav/>,
        document.getElementById('mobile-nav')
    );
}
